import React, { useState, useEffect, useRef } from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import './LearnMore.css';

const OurImpact = React.forwardRef(function OurImpact(props, ref) {
  const [animatedPercentages, setAnimatedPercentages] = useState([0, 0, 0, 0]);
  const sectionRef = useRef(null);
  const timersRef = useRef([]);
  const targets = [70, 90, 50, 60];

  const impacts = [
    { percentage: `${animatedPercentages[0]}%`, label: "Improved Quality Appraisals" },
    { percentage: `${animatedPercentages[1]}%`, label: "Enhanced Operational Efficiency" },
    { percentage: `${animatedPercentages[2]}%`, label: "Boosted Portfolio Performance" },
    { percentage: `${animatedPercentages[3]}%`, label: "Increase in Customer Base" }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            targets.forEach((target, index) => {
              let current = 0;
              const increment = target / 50; // Adjust speed
              const timer = setInterval(() => {
                current += increment;
                if (current >= target) {
                  current = target;
                  clearInterval(timer);
                }
                setAnimatedPercentages((prev) => {
                  const newPrev = [...prev];
                  newPrev[index] = Math.floor(current);
                  return newPrev;
                });
              }, 50);
              timersRef.current.push(timer);
            });
          }
        });
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
      timersRef.current.forEach(clearInterval);
    };
  }, []);

  const combinedRef = (el) => {
    sectionRef.current = el;
    if (ref) ref.current = el;
  };

  return (
    <section ref={combinedRef} id="our-impact" className="impact-section">
      <div className="section-container">
        <div className="section-header-center">
          <h2 className="section-title">Our Impact</h2>
          <div className="title-underline"></div>
        </div>

        <div className="impact-grid">
          {impacts.map((impact, index) => (
            <div key={index} className="impact-card">
              <div className="impact-percentage">{impact.percentage}</div>
              <div className="impact-label">{impact.label}</div>
              <FiCheckCircle className="impact-check" />
            </div>
          ))}
        </div>

        <p className="impact-statement">
          We're helping financial institutions reduce risk, scale faster, and serve millions
          of previously excluded borrowers across Africa.
        </p>
      </div>
    </section>
  );
});

export default OurImpact;